export const LOCALHOST = 'localhost'
export const XE_DEV = 'xe-dev'
export const DEV = 'dev'
export const QA = 'qa'
export const INTEG = 'integ'
export const PROD = 'production'
